import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { CookieOptions, CookieService } from 'ngx-cookie';
import { ACCESS_TOKEN, EXPIRES_IN, REFRESH_TOKEN, TokenStorage } from '../models/token-storage';
import { UserSession } from '../models/user-session';
import { LoginResponse } from '../response/login-response';


@Injectable({
    providedIn: 'root',
})
export class TokenService {

    constructor(private cookieService: CookieService) { }

    public saveToken(loginResponse: LoginResponse): void {
        this.removeTokenSession();
        const options: CookieOptions = {
            expires: new Date(Date.now() + loginResponse[EXPIRES_IN] * 1000),
            path: '/',
            secure: true, // Configurar 'Secure' como verdadero para enviar solo sobre conexiones HTTPS seguras
            sameSite: 'strict' // Opcional, puedes configurar SameSite como 'strict' para restringir envíos de cookies de origen cruzado
          };
        this.cookieService.put(ACCESS_TOKEN, loginResponse[ACCESS_TOKEN],options);
        this.cookieService.put(REFRESH_TOKEN, loginResponse[REFRESH_TOKEN],options);
        this.cookieService.put(EXPIRES_IN, loginResponse[EXPIRES_IN].toString(),options);
    }
 
    get token(): string {
        return this.cookieService?.get(ACCESS_TOKEN);
    }

    get refreshToken(): string {
        return this.cookieService?.get(REFRESH_TOKEN);
    }

    getDecodeToken(): UserSession {
        return jwt_decode(this.token) as UserSession;
    }

    isLoggedIn() {
        return this.token == null ? false : this.token ? true : false;
    }

    signOut(): void {
        this.cookieService.removeAll();
        this.removeTokenSession();
        sessionStorage.clear();
    }

    removeTokenSession(): void {
        this.cookieService.remove(ACCESS_TOKEN);
        this.cookieService.remove(REFRESH_TOKEN);
        this.cookieService.remove(EXPIRES_IN);
    }

}
